import { WWEX_API_CODE, WWEX_DISPLAY_NAME } from './constants';

const PROVIDER_NAME_OVERRIDES: Record<string, string> = {
  [WWEX_API_CODE]: WWEX_DISPLAY_NAME,
};

export const getProviderDisplayName = (name: string, apiCode: string): string => PROVIDER_NAME_OVERRIDES[apiCode] ?? name;
